function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.998 23.968a8.007 8.007 0 006.935-6.932H23a1 1 0 110-2h.933a8.007 8.007 0 00-6.93-6.93v.9a1 1 0 11-2 0v-.9a8.006 8.006 0 00-6.93 6.93h.932a1 1 0 110 2h-.933A8.006 8.006 0 0015 23.966v-.933a1 1 0 012 0v.935zm10.008-8.932a1 1 0 110 2h-1.053c-.471 4.719-4.235 8.48-8.954 8.95v1.053a1 1 0 11-2 0v-1.053c-4.716-.473-8.476-4.234-8.946-8.95H5a1 1 0 110-2h1.053c.471-4.716 4.233-8.478 8.95-8.95V5a1 1 0 112 0v1.087c4.718.47 8.479 4.233 8.95 8.949h1.053zm-9.003 1A2 2 0 1114 16.035a2 2 0 014.002.001z",
  fill: "#000",
  fillRule: "evenodd"
});

function SvgIcMapInteraction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgIcMapInteraction;